import { render, staticRenderFns } from "./CampaignStatusDashboard.vue?vue&type=template&id=2eae97f8&scoped=true"
import script from "./CampaignStatusDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignStatusDashboard.vue?vue&type=script&lang=js"
import style0 from "./CampaignStatusDashboard.vue?vue&type=style&index=0&id=2eae97f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eae97f8",
  null
  
)

export default component.exports